import { travel, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';
import { Dispatch } from 'redux';

import {
  pendingTravelAdminRequest,
  fetchPendingTravelAdmin,
  fetchPendingTravelAdminError,
} from 'action-creators/pendingTravels';
import { RepprovalReason } from 'models/repprovalReason';
import { Response } from 'models/response';

export const getTravelForAdmin = () => async (dispatch: Dispatch) => {
  dispatch(pendingTravelAdminRequest());
  try {
    const response = await travel.get('travels/GetPendingTravels', axiosConfig);
    dispatch(fetchPendingTravelAdmin(response));
  } catch (error) {
    dispatch(fetchPendingTravelAdminError(error));
  }
};

export const approveOrReproveTravel = async (
  travelId: string,
  isApproval: boolean,
  approverId: string,
  reason?: RepprovalReason,
): Promise<AxiosResponse<Response<any>>> => {
  let adminApprover;
  if (isApproval) {
    adminApprover = {
      travelId,
      approverId,
    };
  } else if (!isApproval) {
    adminApprover = {
      travelId,
      disapproverId: approverId,
      rejectedReasonId: reason?.id ?? null,
    };
  }
  return await travel.put(`Travels/${isApproval ? 'Approve' : 'Reprove'}/${travelId}`, adminApprover).catch((error) => {
    throw error;
  });
};

export const fetchTravel = async (travelId: string) =>
  travel.get(`Travels/GetTravelDetailById?TravelId=${travelId}`, axiosConfig);

export const getRepprovalReasons = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const data = travel
        .get<RepprovalReason[]>('Travels/GetRejectedReasonsForTravel')
        .then((response) => response.data);

      resolve(data);
    } catch (ex) {
      reject(ex);
    }
  });
